import { useQuery, useQueryClient } from 'react-query'
import { useLocation } from 'react-router-dom'
import { isUUID } from 'utils'
import { Club } from '@fable/types'
import { getClub } from '../apiHelpers'
import { useEffect } from 'react'
import { getClubSlug } from '../utils'
import { useErrorModal, useInviteId } from 'hooks'

export const useClubQuery = () => {
  const { pathname } = useLocation()
  const slug = getClubSlug(pathname)
  const queryClient = useQueryClient()
  const inviteId = useInviteId()

  const clubQuery = useQuery(['club'], () => getClub(slug), {
    enabled: !!slug,
  })

  useErrorModal(clubQuery.error)

  useEffect(() => {
    return () => {
      queryClient.removeQueries({ queryKey: ['club'] })
    }
  }, [queryClient])

  const club: Club = isUUID(slug)
    ? clubQuery?.data?.data
    : clubQuery?.data?.data?.results[0]

  return { club, clubQuery, inviteId }
}
